/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DataRouteImport } from './routes/data'
import { Route as IdentifyRouteImport } from './routes/identify'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as InstructionsRouteImport } from './routes/instructions'
import { Route as MapRouteImport } from './routes/map'
import { Route as OfflineRouteImport } from './routes/offline'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as RecipesRouteImport } from './routes/recipes'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SpeciesRouteImport } from './routes/species'
import { Route as SupportRouteImport } from './routes/support'
import { Route as TermsuseRouteImport } from './routes/termsuse'
import { Route as WorthForagingNowRouteImport } from './routes/worth-foraging-now'
import { Route as DataSeasonsIndexRouteImport } from './routes/data_.seasons.index'
import { Route as DataSeasonsPlaceSpeciesRouteImport } from './routes/data_.seasons.$place.$species'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DataRoute = DataRouteImport.update({
  id: '/data',
  path: '/data',
  getParentRoute: () => rootRouteImport,
} as any)
const IdentifyRoute = IdentifyRouteImport.update({
  id: '/identify',
  path: '/identify',
  getParentRoute: () => rootRouteImport,
} as any)
const ImpressumRoute = ImpressumRouteImport.update({
  id: '/impressum',
  path: '/impressum',
  getParentRoute: () => rootRouteImport,
} as any)
const InstructionsRoute = InstructionsRouteImport.update({
  id: '/instructions',
  path: '/instructions',
  getParentRoute: () => rootRouteImport,
} as any)
const MapRoute = MapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => rootRouteImport,
} as any)
const OfflineRoute = OfflineRouteImport.update({
  id: '/offline',
  path: '/offline',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const RecipesRoute = RecipesRouteImport.update({
  id: '/recipes',
  path: '/recipes',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SpeciesRoute = SpeciesRouteImport.update({
  id: '/species',
  path: '/species',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsuseRoute = TermsuseRouteImport.update({
  id: '/termsuse',
  path: '/termsuse',
  getParentRoute: () => rootRouteImport,
} as any)
const WorthForagingNowRoute = WorthForagingNowRouteImport.update({
  id: '/worth-foraging-now',
  path: '/worth-foraging-now',
  getParentRoute: () => rootRouteImport,
} as any)
const DataSeasonsIndexRoute = DataSeasonsIndexRouteImport.update({
  id: '/data_/seasons/',
  path: '/data/seasons/',
  getParentRoute: () => rootRouteImport,
} as any)
const DataSeasonsPlaceSpeciesRoute = DataSeasonsPlaceSpeciesRouteImport.update({
  id: '/data_/seasons/$place/$species',
  path: '/data/seasons/$place/$species',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/data': typeof DataRoute
  '/identify': typeof IdentifyRoute
  '/impressum': typeof ImpressumRoute
  '/instructions': typeof InstructionsRoute
  '/map': typeof MapRoute
  '/offline': typeof OfflineRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/recipes': typeof RecipesRoute
  '/settings': typeof SettingsRoute
  '/species': typeof SpeciesRoute
  '/support': typeof SupportRoute
  '/termsuse': typeof TermsuseRoute
  '/worth-foraging-now': typeof WorthForagingNowRoute
  '/data/seasons/': typeof DataSeasonsIndexRoute
  '/data/seasons/$place/$species': typeof DataSeasonsPlaceSpeciesRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/data': typeof DataRoute
  '/identify': typeof IdentifyRoute
  '/impressum': typeof ImpressumRoute
  '/instructions': typeof InstructionsRoute
  '/map': typeof MapRoute
  '/offline': typeof OfflineRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/recipes': typeof RecipesRoute
  '/settings': typeof SettingsRoute
  '/species': typeof SpeciesRoute
  '/support': typeof SupportRoute
  '/termsuse': typeof TermsuseRoute
  '/worth-foraging-now': typeof WorthForagingNowRoute
  '/data/seasons': typeof DataSeasonsIndexRoute
  '/data/seasons/$place/$species': typeof DataSeasonsPlaceSpeciesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/data': typeof DataRoute
  '/identify': typeof IdentifyRoute
  '/impressum': typeof ImpressumRoute
  '/instructions': typeof InstructionsRoute
  '/map': typeof MapRoute
  '/offline': typeof OfflineRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/recipes': typeof RecipesRoute
  '/settings': typeof SettingsRoute
  '/species': typeof SpeciesRoute
  '/support': typeof SupportRoute
  '/termsuse': typeof TermsuseRoute
  '/worth-foraging-now': typeof WorthForagingNowRoute
  '/data_/seasons/': typeof DataSeasonsIndexRoute
  '/data_/seasons/$place/$species': typeof DataSeasonsPlaceSpeciesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/data'
    | '/identify'
    | '/impressum'
    | '/instructions'
    | '/map'
    | '/offline'
    | '/privacy-policy'
    | '/recipes'
    | '/settings'
    | '/species'
    | '/support'
    | '/termsuse'
    | '/worth-foraging-now'
    | '/data/seasons/'
    | '/data/seasons/$place/$species'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/data'
    | '/identify'
    | '/impressum'
    | '/instructions'
    | '/map'
    | '/offline'
    | '/privacy-policy'
    | '/recipes'
    | '/settings'
    | '/species'
    | '/support'
    | '/termsuse'
    | '/worth-foraging-now'
    | '/data/seasons'
    | '/data/seasons/$place/$species'
  id:
    | '__root__'
    | '/'
    | '/data'
    | '/identify'
    | '/impressum'
    | '/instructions'
    | '/map'
    | '/offline'
    | '/privacy-policy'
    | '/recipes'
    | '/settings'
    | '/species'
    | '/support'
    | '/termsuse'
    | '/worth-foraging-now'
    | '/data_/seasons/'
    | '/data_/seasons/$place/$species'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DataRoute: typeof DataRoute
  IdentifyRoute: typeof IdentifyRoute
  ImpressumRoute: typeof ImpressumRoute
  InstructionsRoute: typeof InstructionsRoute
  MapRoute: typeof MapRoute
  OfflineRoute: typeof OfflineRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  RecipesRoute: typeof RecipesRoute
  SettingsRoute: typeof SettingsRoute
  SpeciesRoute: typeof SpeciesRoute
  SupportRoute: typeof SupportRoute
  TermsuseRoute: typeof TermsuseRoute
  WorthForagingNowRoute: typeof WorthForagingNowRoute
  DataSeasonsIndexRoute: typeof DataSeasonsIndexRoute
  DataSeasonsPlaceSpeciesRoute: typeof DataSeasonsPlaceSpeciesRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data': {
      id: '/data'
      path: '/data'
      fullPath: '/data'
      preLoaderRoute: typeof DataRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/identify': {
      id: '/identify'
      path: '/identify'
      fullPath: '/identify'
      preLoaderRoute: typeof IdentifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/impressum': {
      id: '/impressum'
      path: '/impressum'
      fullPath: '/impressum'
      preLoaderRoute: typeof ImpressumRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/instructions': {
      id: '/instructions'
      path: '/instructions'
      fullPath: '/instructions'
      preLoaderRoute: typeof InstructionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/map': {
      id: '/map'
      path: '/map'
      fullPath: '/map'
      preLoaderRoute: typeof MapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/offline': {
      id: '/offline'
      path: '/offline'
      fullPath: '/offline'
      preLoaderRoute: typeof OfflineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recipes': {
      id: '/recipes'
      path: '/recipes'
      fullPath: '/recipes'
      preLoaderRoute: typeof RecipesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/species': {
      id: '/species'
      path: '/species'
      fullPath: '/species'
      preLoaderRoute: typeof SpeciesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/termsuse': {
      id: '/termsuse'
      path: '/termsuse'
      fullPath: '/termsuse'
      preLoaderRoute: typeof TermsuseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/worth-foraging-now': {
      id: '/worth-foraging-now'
      path: '/worth-foraging-now'
      fullPath: '/worth-foraging-now'
      preLoaderRoute: typeof WorthForagingNowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data_/seasons/': {
      id: '/data_/seasons/'
      path: '/data/seasons'
      fullPath: '/data/seasons/'
      preLoaderRoute: typeof DataSeasonsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data_/seasons/$place/$species': {
      id: '/data_/seasons/$place/$species'
      path: '/data/seasons/$place/$species'
      fullPath: '/data/seasons/$place/$species'
      preLoaderRoute: typeof DataSeasonsPlaceSpeciesRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DataRoute: DataRoute,
  IdentifyRoute: IdentifyRoute,
  ImpressumRoute: ImpressumRoute,
  InstructionsRoute: InstructionsRoute,
  MapRoute: MapRoute,
  OfflineRoute: OfflineRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  RecipesRoute: RecipesRoute,
  SettingsRoute: SettingsRoute,
  SpeciesRoute: SpeciesRoute,
  SupportRoute: SupportRoute,
  TermsuseRoute: TermsuseRoute,
  WorthForagingNowRoute: WorthForagingNowRoute,
  DataSeasonsIndexRoute: DataSeasonsIndexRoute,
  DataSeasonsPlaceSpeciesRoute: DataSeasonsPlaceSpeciesRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
